webpackJsonp([1],{

/***/ 130:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_default_index_css__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_default_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_default_index_css__);






__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_element_ui___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),

/***/ 131:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_header__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_header__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',

  components: {
    MainHeader: __WEBPACK_IMPORTED_MODULE_0__components_header___default.a
  }
});

/***/ }),

/***/ 132:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__i18n_content__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__i18n_content___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__i18n_content__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_marked__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_marked___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_marked__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hanabi__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hanabi___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_hanabi__);









var comment = '<!-- Created by issues bot. DO NOT REMOVE. -->';

__WEBPACK_IMPORTED_MODULE_4_marked___default.a.setOptions({
  gfm: true,
  tables: true,
  breaks: false,
  pedantic: false,
  sanitize: true,
  smartLists: true,
  smartypants: false,
  highlight: function highlight(code) {
    return __WEBPACK_IMPORTED_MODULE_5_hanabi___default()(code);
  }
});

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'main-content',

  data: function data() {
    var repo = this.$route.query.repo;

    var queryRepo = 'VueCesium';
    if (repo === 'element-plus') {
      queryRepo = 'VueCesium';
    }

    return {
      form: {
        repo: queryRepo,
        title: '',
        type: '',
        desc: '',
        versionRepository: '',
        versionVue: '',
        versionBrowser: '',
        versionCesium: '',
        reproduce: '',
        steps: '',
        expected: '',
        actual: '',
        existingComponent: true,
        componentName: ''
      },
      query: {
        repo: queryRepo
      },
      show: false,
      loading: {
        repository: false,
        vue: false
      },
      version: {
        repo: [],
        vue: [],
        cesium: []
      },
      issue: ''
    };
  },


  computed: {
    versionVue: function versionVue() {
      return this.version.vue;
    },
    versionCesium: function versionCesium() {
      return this.version.cesium;
    },
    lang: function lang() {
      return this.$route.path.split('/')[1] || window.navigator.language;
    },
    contents: function contents() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2__i18n_content___default.a.filter(function (c) {
        return c.lang === _this.lang;
      })[0];
    },
    api: function api() {
      return {
        repositoryVersion: 'https://data.jsdelivr.com/v1/package/npm/' + (this.repo && this.repo.npm),
        vueVersion: 'https://data.jsdelivr.com/v1/package/npm/vue',
        cesiumVersion: 'https://data.jsdelivr.com/v1/package/npm/cesium'
      };
    },
    isBug: function isBug() {
      return !this.contents.issueTypes.indexOf(this.form.type);
    },
    rules: function rules() {
      var _this2 = this;

      var valid = this.contents.valid;
      var rules = {};
      for (var prop in valid) {
        rules[prop] = [{
          required: true,
          trigger: 'change',
          message: valid[prop]
        }];
      }

      rules['reproduce'].push({
        trigger: 'blur',
        validator: function validator(rule, val, cb) {
          if (_this2.repo.reproduceLinks.some(function (_) {
            return _.link === val;
          })) {
            cb({
              'zh-CN': '请填写正确的重现链接，不要直接复制示意链接',
              'en-US': 'Please provide correct link, do not copy the demo link directly'
            }[_this2.lang]);
          } else if (/(github|jsfiddle|codepen|jsbin|codesandbox)/ig.test(val)) {
            cb();
          } else {
            cb({
              'zh-CN': '请填写正确的重现链接',
              'en-US': 'Please provide correct link'
            }[_this2.lang]);
          }
        }
      });

      return rules;
    },
    repo: function repo() {
      var _this3 = this;

      return this.contents.repos.filter(function (r) {
        return r.name === _this3.form.repo;
      })[0];
    },
    issueHTML: function issueHTML() {
      return __WEBPACK_IMPORTED_MODULE_4_marked___default()(this.issue);
    },
    title: function title() {
      var prefix = '[' + (this.isBug ? 'Bug Report' : 'Feature Request') + '] ';
      return encodeURIComponent(prefix + this.form.title).replace(/%2B/gi, '+');
    },
    body: function body() {
      var issue = '\n' + comment + '\n\n' + this.issue + '\n\n' + comment + '\n';
      return encodeURIComponent(issue).replace(/%2B/gi, '+');
    }
  },

  watch: {
    lang: {
      handler: function handler() {
        var _this4 = this;

        this.$nextTick(function () {
          _this4.$refs.form.resetFields();
          _this4.form.repo = _this4.query.repo || _this4.contents.repos[0].name;
          _this4.form.versionRepository = _this4.version.repo[0];
          _this4.form.versionVue = _this4.versionVue[0];
          _this4.form.type = _this4.contents.issueTypes[0];
        });
      },

      immediate: true
    },

    'form.repo': {
      handler: function handler() {
        this.fetchRepositoryVersion();
        this.form.versionVue = this.versionVue[0];
      },

      immediate: true
    },

    '$route.query': {
      handler: function handler(val) {},

      immediate: true
    }
  },

  methods: {
    preview: function preview() {
      var _this5 = this;

      this.$refs.form.validate(function (valid) {
        if (valid) {
          _this5.createIssue();
        }
      });
    },
    create: function create() {
      window.open('https://github.com/' + this.repo.github + '/issues/new?title=' + this.title + '&body=' + this.body);
    },
    createIssue: function createIssue() {
      this.issue = this.isBug ? ('\n### ' + this.form.repo + ' version\n' + this.form.versionRepository + '\n\n### OS/Browsers version\n' + this.form.versionBrowser + '\n\n### Vue version\n' + this.form.versionVue + '\n\n### Cesium version\n' + this.form.versionCesium + '\n\n### Reproduction Link\n' + this.form.reproduce + '\n\n### Steps to reproduce\n' + this.form.steps + '\n\n### What is Expected?\n' + this.form.expect + '\n\n### What is actually happening?\n' + this.form.actual + '\n').trim() : ('\n### Existing Component\n' + (this.form.existingComponent ? this.contents.existingComponentYes : this.contents.existingComponentNo) + '\n\n### Component Name\n' + this.form.componentName + '\n\n### Description\n' + this.form.desc + '\n').trim();
      this.show = true;
    },
    fetchRepositoryVersion: function fetchRepositoryVersion() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(_this6.api.repositoryVersion);

              case 2:
                response = _context.sent;

                _this6.version.repo = response.data.versions.filter(function (_) {
                  return ['1.0.2-beta.12'].indexOf(_) < 0;
                });
                _this6.form.versionRepository = _this6.version.repo[0];

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this6);
      }))();
    },
    fetchVueVersion: function fetchVueVersion() {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(_this7.api.vueVersion);

              case 2:
                response = _context2.sent;

                _this7.version.vue = response.data.versions;
                _this7.form.versionVue = _this7.versionVue[0];

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this7);
      }))();
    },
    fetchCesiumVersion: function fetchCesiumVersion() {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(_this8.api.cesiumVersion);

              case 2:
                response = _context3.sent;

                _this8.version.cesium = response.data.versions;
                _this8.form.versionCesium = _this8.versionCesium[0];

              case 5:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this8);
      }))();
    }
  },

  mounted: function mounted() {
    this.fetchVueVersion();
    this.fetchCesiumVersion();
  }
});

/***/ }),

/***/ 133:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'main-header',

  data: function data() {
    return {
      language: ''
    };
  },


  computed: {
    lang: function lang() {
      return this.$route.path.split('/')[1] || window.navigator.language;
    }
  },

  watch: {
    lang: {
      handler: function handler(val) {
        this.language = val;
      },

      immediate: true
    }
  }
});

/***/ }),

/***/ 195:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 196:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 197:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 204:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 205:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(197)

var Component = __webpack_require__(51)(
  /* script */
  __webpack_require__(132),
  /* template */
  __webpack_require__(209),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 206:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(196)

var Component = __webpack_require__(51)(
  /* script */
  __webpack_require__(133),
  /* template */
  __webpack_require__(208),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 207:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('main-header'), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 208:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', [_c('el-menu', {
    attrs: {
      "theme": "dark",
      "mode": "horizontal",
      "default-active": _vm.language,
      "router": true
    }
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/zouyaoji/vue-cesium",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(204)
    }
  })])]), _c('el-menu-item', {
    staticClass: "right",
    attrs: {
      "index": "zh-CN"
    }
  }, [_vm._v("中文")]), _c('el-menu-item', {
    staticClass: "right",
    attrs: {
      "index": "en-US"
    }
  }, [_vm._v("English")])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 209:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', [_c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center"
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 18,
      "sm": 18,
      "md": 12
    }
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.contents.intro)
    }
  }), _c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules,
      "label-position": "top"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.contents.repoSelectHint,
      "prop": "repo"
    }
  }, [_c('el-select', {
    staticClass: "block",
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.form.repo),
      callback: function($$v) {
        _vm.$set(_vm.form, "repo", $$v)
      },
      expression: "form.repo"
    }
  }, _vm._l((_vm.contents.repos), function(repo, index) {
    return _c('el-option', {
      key: repo.github,
      attrs: {
        "label": repo.name,
        "value": repo.name
      }
    })
  }), 1)], 1), _c('el-form-item', {
    attrs: {
      "label": _vm.contents.issueTypesHint,
      "prop": "type"
    }
  }, [_c('el-select', {
    staticClass: "block",
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.form.type),
      callback: function($$v) {
        _vm.$set(_vm.form, "type", $$v)
      },
      expression: "form.type"
    }
  }, _vm._l((_vm.contents.issueTypes), function(type) {
    return _c('el-option', {
      key: type,
      attrs: {
        "label": type,
        "value": type
      }
    })
  }), 1)], 1), _c('el-form-item', {
    attrs: {
      "label": _vm.contents.issueTitleHint,
      "prop": "title"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.title),
      callback: function($$v) {
        _vm.$set(_vm.form, "title", $$v)
      },
      expression: "form.title"
    }
  })], 1), (_vm.isBug) ? [_c('el-form-item', [_c('small', [_c('p', {
    domProps: {
      "textContent": _vm._s(_vm.contents.issueUsage)
    }
  }), _c('ul', _vm._l((_vm.contents.links[_vm.form.repo]), function(l) {
    return _c('li', {
      key: l.link
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(l.desc)
      }
    }), _c('a', {
      attrs: {
        "href": l.link,
        "target": "_blank"
      },
      domProps: {
        "textContent": _vm._s(l.link)
      }
    })])
  }), 0), _c('b', {
    domProps: {
      "textContent": _vm._s(_vm.contents.issueHint)
    }
  })])]), _c('el-form-item', {
    attrs: {
      "label": _vm.contents.versionRepositoryHint,
      "prop": "versionRepository"
    }
  }, [_c('el-select', {
    staticClass: "block",
    attrs: {
      "filterable": "filterable",
      "loading": _vm.loading.repository,
      "no-match-text": _vm.contents.noMatchText,
      "no-data-text": _vm.contents.noDataText,
      "placeholder": ""
    },
    model: {
      value: (_vm.form.versionRepository),
      callback: function($$v) {
        _vm.$set(_vm.form, "versionRepository", $$v)
      },
      expression: "form.versionRepository"
    }
  }, _vm._l((_vm.version.repo), function(tag) {
    return _c('el-option', {
      key: tag,
      attrs: {
        "label": tag,
        "value": tag
      }
    })
  }), 1)], 1), _c('el-form-item', {
    attrs: {
      "label": _vm.contents.versionBrowserHint,
      "prop": "versionBrowser"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.versionBrowser),
      callback: function($$v) {
        _vm.$set(_vm.form, "versionBrowser", $$v)
      },
      expression: "form.versionBrowser"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": _vm.contents.versionVueHint,
      "prop": "versionVue"
    }
  }, [_c('el-select', {
    staticClass: "block",
    attrs: {
      "filterable": "filterable",
      "loading": _vm.loading.vue,
      "no-match-text": _vm.contents.noMatchText,
      "no-data-text": _vm.contents.noDataText,
      "placeholder": ""
    },
    model: {
      value: (_vm.form.versionVue),
      callback: function($$v) {
        _vm.$set(_vm.form, "versionVue", $$v)
      },
      expression: "form.versionVue"
    }
  }, _vm._l((_vm.versionVue), function(tag) {
    return _c('el-option', {
      key: tag,
      attrs: {
        "label": tag,
        "value": tag
      }
    })
  }), 1)], 1), _c('el-form-item', {
    attrs: {
      "label": _vm.contents.versionCesiumHint,
      "prop": "versionCesium"
    }
  }, [_c('el-select', {
    staticClass: "block",
    attrs: {
      "filterable": "filterable",
      "loading": _vm.loading.vue,
      "no-match-text": _vm.contents.noMatchText,
      "no-data-text": _vm.contents.noDataText,
      "placeholder": ""
    },
    model: {
      value: (_vm.form.versionCesium),
      callback: function($$v) {
        _vm.$set(_vm.form, "versionCesium", $$v)
      },
      expression: "form.versionCesium"
    }
  }, _vm._l((_vm.versionCesium), function(tag) {
    return _c('el-option', {
      key: tag,
      attrs: {
        "label": tag,
        "value": tag
      }
    })
  }), 1)], 1), _c('el-form-item', {
    attrs: {
      "label": _vm.contents.reproduceHint,
      "prop": "reproduce"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.reproduce),
      callback: function($$v) {
        _vm.$set(_vm.form, "reproduce", $$v)
      },
      expression: "form.reproduce"
    }
  })], 1), _c('el-form-item', [_c('small', [_c('p', {
    domProps: {
      "textContent": _vm._s(_vm.contents.reproduceHintSmall)
    }
  }), _c('ul', _vm._l((_vm.repo.reproduceLinks), function(l) {
    return _c('li', [_c('a', {
      attrs: {
        "href": l.link,
        "target": "_blank"
      },
      domProps: {
        "textContent": _vm._s(l.name)
      }
    })])
  }), 0)])]), _c('el-form-item', {
    attrs: {
      "label": _vm.contents.stepsHint,
      "prop": "steps"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 5,
        maxRows: 10
      }
    },
    model: {
      value: (_vm.form.steps),
      callback: function($$v) {
        _vm.$set(_vm.form, "steps", $$v)
      },
      expression: "form.steps"
    }
  })], 1), _c('el-form-item', [_c('small', {
    domProps: {
      "innerHTML": _vm._s(_vm.contents.stepsHintSmall)
    }
  })]), _c('el-form-item', {
    attrs: {
      "label": _vm.contents.expectHint,
      "prop": "expect"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 5,
        maxRows: 10
      }
    },
    model: {
      value: (_vm.form.expect),
      callback: function($$v) {
        _vm.$set(_vm.form, "expect", $$v)
      },
      expression: "form.expect"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": _vm.contents.actualHint,
      "prop": "actual"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 5,
        maxRows: 10
      }
    },
    model: {
      value: (_vm.form.actual),
      callback: function($$v) {
        _vm.$set(_vm.form, "actual", $$v)
      },
      expression: "form.actual"
    }
  })], 1)] : [_c('el-form-item', {
    attrs: {
      "label": _vm.contents.existingComponentHint,
      "prop": "existingComponent"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": true
    },
    model: {
      value: (_vm.form.existingComponent),
      callback: function($$v) {
        _vm.$set(_vm.form, "existingComponent", $$v)
      },
      expression: "form.existingComponent"
    }
  }, [_vm._v(_vm._s(_vm.contents.existingComponentYes))]), _c('el-radio', {
    attrs: {
      "label": false
    },
    model: {
      value: (_vm.form.existingComponent),
      callback: function($$v) {
        _vm.$set(_vm.form, "existingComponent", $$v)
      },
      expression: "form.existingComponent"
    }
  }, [_vm._v(_vm._s(_vm.contents.existingComponentNo))])], 1), _c('el-form-item', {
    attrs: {
      "label": _vm.contents.componentNameHint,
      "prop": "componentName"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.componentName),
      callback: function($$v) {
        _vm.$set(_vm.form, "componentName", $$v)
      },
      expression: "form.componentName"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": _vm.contents.descHint,
      "prop": "desc"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 5,
        maxRows: 10
      }
    },
    model: {
      value: (_vm.form.desc),
      callback: function($$v) {
        _vm.$set(_vm.form, "desc", $$v)
      },
      expression: "form.desc"
    }
  })], 1)], _c('el-form-item', {
    staticClass: "center"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    domProps: {
      "textContent": _vm._s(_vm.contents.preview)
    },
    on: {
      "click": _vm.preview
    }
  })], 1)], 2)], 1)], 1), _c('el-dialog', {
    attrs: {
      "title": _vm.contents.dialog.title
    },
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.issueHTML)
    }
  }), _c('span', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    domProps: {
      "textContent": _vm._s(_vm.contents.dialog.button)
    },
    on: {
      "click": _vm.create
    }
  })], 1)])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 212:
/***/ (function(module, exports) {

module.exports = [{"lang":"zh-CN","intro":"Hi，我们为了中文用户的方便提供了中文的表单，但在填写时请<strong>尽量使用英文</strong>。","repoSelectHint":"选择要提交 issue 的库","repos":[{"name":"VueCesium","github":"zouyaoji/vue-cesium","npm":"vue-cesium","reproduceLinks":[{"name":"codepen","link":"https://codepen.io/zouyaoji/pen/bGBOyJM"},{"name":"codesandbox","link":"https://codesandbox.io/p/github/zouyaoji/vue-cesium-demo/main"},{"name":"stackblitz-project","link":"https://stackblitz.com/edit/vue-cesium-demo?file=index.html"},{"name":"stackblitz-repository","link":"https://stackblitz.com/~/github.com/zouyaoji/vue-cesium-demo"}]}],"issueTitleHint":"Issue 标题","issueTypesHint":"Issue 类别","issueTypes":["Bug","新特性"],"issueUsage":"Issue 是用作提交 Bug 以及请求新特性的，对于简单的问题，请查阅以下资源：","links":{"VueCesium":[{"desc":"官网：","link":"https://zouyaoji.top/vue-cesium/#/zh-CN"},{"desc":"文档：","link":"https://zouyaoji.top/vue-cesium/#/zh-CN/component/"}]},"issueHint":"在提交 issue 前，请先进行搜索来保证没有类似的 issue。","versionRepositoryHint":"项目版本","versionRepositoryHintSmall":"请检查在最新版本中能否重现此 issue。","versionBrowserHint":"操作系统版本 / 浏览器版本","versionVueHint":"Vue 版本","versionCesiumHint":"Cesium 版本","reproduceHint":"重现链接","reproduceHintSmall":"请提供可以重现 issue 的链接或者项目，例如：","stepsHint":"重现步骤","stepsHintSmall":"<p>请清晰的描述重现该 issue 的步骤，没有清晰重现步骤的 issue 将不会被修复。标有<code>need repro</code>的 issue 如果在 7 天内不提供相关步骤，将直接被关闭。</p>","expectHint":"期待的行为","actualHint":"实际的行为","descHint":"Issue 描述","preview":"预览","valid":{"repo":"请选择库名","title":"请填写 issue 标题","type":"请选择 issue 类别","versionRepository":"请选择项目的版本","versionBrowser":"请填写操作系统版本/浏览器版本","versionVue":"请选择 Vue 的版本","reproduce":"请填写重现链接","steps":"请填写重现步骤","expect":"请填写期待的行为","actual":"请填写实际的表现","desc":" 请填写描述","componentName":"请填写组件名"},"loadingText":"加载中","noMatchText":"无匹配数据","noDataText":"无数据","dialog":{"title":"Issue 预览","button":"创建"},"existingComponentHint":"是否是已有组件？","existingComponentYes":"是","existingComponentNo":"否","componentNameHint":"组件名"},{"lang":"en-US","intro":"","repoSelectHint":"I am opening an issue for","repos":[{"name":"VueCesium","github":"zouyaoji/vue-cesium","npm":"vue-cesium","reproduceLinks":[{"name":"codepen","link":"https://codepen.io/zouyaoji/pen/bGBOyJM"},{"name":"codesandbox","link":"https://codesandbox.io/s/vue-cesium-start-ecxmo?file=/src/App.vue"},{"name":"stackblitz-project","link":"https://stackblitz.com/edit/vue-cesium-demo?file=index.html"},{"name":"stackblitz-repository","link":"https://stackblitz.com/~/github.com/zouyaoji/vue-cesium-demo"}]}],"issueTitleHint":"Issue Title","issueTypesHint":"Issue Type","issueTypes":["Bug Report","Feature Request"],"issueUsage":"The issue list of this repo is exclusively for bug reports and feature requests. For simple questions, please use the following resources:","links":{"VueCesium":[{"desc":"HomePage: ","link":"https://zouyaoji.top/vue-cesium/#/zh-CN"},{"desc":"Docs: ","link":"https://zouyaoji.top/vue-cesium/#/zh-CN/component/"}]},"issueHint":"Try to search for your issue, it may have already been answered or even fixed in the development branch.","versionRepositoryHint":"Repository Version","versionRepositoryHintSmall":"Check if the issue is reproducible with the latest stable version of Repository.","versionBrowserHint":"OS / Browser Version","versionVueHint":"Vue Version","versionCesiumHint":"Cesium Version","reproduceHint":"Reproduction Link","reproduceHintSmall":"Use jsfiddle/codepen/codesandbox to reproduce issue. If it requires build setup, then create a project and provide a link to a repository.","stepsHint":"Steps to reproduce","stepsHintSmall":"<p>It is <b>required</b> that you clearly describe the steps necessary to reproduce the issue you are running into. Issues with no clear repro steps will not be triaged. If an issue labeled <code>need repro</code> receives no further input from the issue author for more than 7 days, it will be closed.</p>","expectHint":"What is Expected?","actualHint":"What is actually happening?","descHint":"Issue Description","preview":"Preview","valid":{"repo":"Please select repo.","title":"Please provide issue title.","type":"Please select type of issue","versionRepository":"Please select version of Repository.","versionBrowser":"Please select version of OS/Browser.","versionVue":"Please select version of Vue.","reproduce":"Please provide reproduction link.","steps":"Please provide steps to reproduce.","expect":"Please provide what is expected?","actual":"Please provide what is actually happening?","desc":" Please provide description.","componentName":"Please provide the name of component."},"loadingText":"loading","noMatchText":"no matching data","noDataText":"no data","dialog":{"title":"Issue Preview","button":"Create"},"existingComponentHint":"Existing component?","existingComponentYes":"Yes","existingComponentNo":"No","componentNameHint":"Component Name"}]

/***/ }),

/***/ 85:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_content__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_content___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_content__);




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var lang = window.navigator.language === 'zh-CN' ? 'zh-CN' : 'en-US';

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/en-US',
    name: 'en-US',
    component: __WEBPACK_IMPORTED_MODULE_2__components_content___default.a
  }, {
    path: '/zh-CN',
    name: 'zh-CN',
    component: __WEBPACK_IMPORTED_MODULE_2__components_content___default.a
  }, {
    path: '*',
    redirect: '/' + lang
  }]
}));

/***/ }),

/***/ 87:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 88:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(195)

var Component = __webpack_require__(51)(
  /* script */
  __webpack_require__(131),
  /* template */
  __webpack_require__(207),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ })

},[130]);


// WEBPACK FOOTER //
// static/js/app.409607a9c6e12d50c831.js